'use strict';

function normalizePathForRouting(inputPath) {
  if (typeof inputPath !== 'string') return '';

  const trimmed = inputPath.trim();
  if (!trimmed || trimmed === '/') return '';

  return trimmed.replace(/^\/+|\/+$/g, '');
}

function isDynamicSegment(segment) {
  return typeof segment === 'string' && segment.startsWith(':') && segment.length > 1;
}

function isSupportedDynamicPattern(layoutKey) {
  const normalized = normalizePathForRouting(layoutKey);
  if (!normalized.includes(':')) return false;

  const segments = normalized.split('/');
  let sawDynamicSegment = false;

  for (const segment of segments) {
    if (isDynamicSegment(segment)) {
      sawDynamicSegment = true;
      continue;
    }

    if (sawDynamicSegment) {
      return false;
    }
  }

  return true;
}

function resolveLayoutForPath(layouts, requestPath) {
  const safeLayouts = layouts || {};
  const resolvedPath = normalizePathForRouting(requestPath);

  if (!resolvedPath) {
    if (safeLayouts.default) {
      return {
        layoutKey: 'default',
        layout: safeLayouts.default,
        params: {},
        resolvedPath: ''
      };
    }
    return null;
  }

  if (safeLayouts[resolvedPath]) {
    return {
      layoutKey: resolvedPath,
      layout: safeLayouts[resolvedPath],
      params: {},
      resolvedPath
    };
  }

  for (const [layoutKey, layout] of Object.entries(safeLayouts)) {
    if (!isSupportedDynamicPattern(layoutKey)) continue;

    const patternSegments = normalizePathForRouting(layoutKey).split('/');
    const pathSegments = resolvedPath.split('/');

    if (patternSegments.length !== pathSegments.length) continue;

    const params = {};
    let matches = true;

    for (let i = 0; i < patternSegments.length; i += 1) {
      const patternSegment = patternSegments[i];
      const pathSegment = pathSegments[i];

      if (isDynamicSegment(patternSegment)) {
        params[patternSegment.slice(1)] = pathSegment;
        continue;
      }

      if (patternSegment !== pathSegment) {
        matches = false;
        break;
      }
    }

    if (matches) {
      return {
        layoutKey,
        layout,
        params,
        resolvedPath
      };
    }
  }

  return null;
}

module.exports = {
  normalizePathForRouting,
  isSupportedDynamicPattern,
  resolveLayoutForPath
};
